module.exports = __webpack_public_path__ + "static/img/AIR_RA800-edited.5f76176.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AIR_RA800-edited.png
// module id = dG2B
// module chunks = 1